/*******************************************************************************
 * Copyright     : Copyright (c)  2025 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc.No part may be reproduced or transmitted in any form by any
 *                 means or for anypurpose without the express written permission of Honeywell. *
 *******************************************************************************/
import React, { useEffect } from "react";

//@Packages
import { useTranslation } from "react-i18next";
import {
  Modal,
  Button,
  PageLoader
} from "@forge/common";

//@Models
import { ServiceLogsProps } from "../../../../models/softwaredetails";

//@Utils
import { SOFTWARE_CONSTANTS } from "../../../../utils/constants";

//@Styles
import "./index.scss";

interface ServiceLogsModalProps extends ServiceLogsProps {
  isOpen: boolean;
  onClose: () => void;
}

const ServiceLogs: React.FC<ServiceLogsModalProps> = ({
  isOpen,
  onClose,
  serviceKey,
  serviceLogs,
  showLogsLoader,
  fetchServiceLogs
}) => {
  const { t } = useTranslation();

  const onRefreshClick = () => {
    if (fetchServiceLogs) {
      fetchServiceLogs(serviceKey);
    }
  };

  const displayLogs = () => {
    try {
      if (serviceLogs && serviceLogs.length > 0) {
        return (
          <div className="logs-display">
            {serviceLogs.map((logLine, index) => (
              <div key={index} className="log-line">
                {logLine}
              </div>
            ))}
          </div>
        );
      } else {
        return (
          <div className="no-logs-message">
            {t(SOFTWARE_CONSTANTS.noLogsFound)}
          </div>
        );
      }
    } catch (error) {
      return (
        <div className="no-logs-message">
          {t(SOFTWARE_CONSTANTS.noLogsFound)}
        </div>
      );
    }
  };
  if (!isOpen) return null;

  return (
        <Modal 
          backdrop
          title={t(SOFTWARE_CONSTANTS.softwareLogs)}
          className="software-log-modal" 
          onModalClose={onClose}
          onBackdropClick={onClose}
        >
          <div className="software-log-content">
            {showLogsLoader ? (
              <PageLoader 
                isLoading={true}
                content={t(SOFTWARE_CONSTANTS.fetchingSoftwareLogs)}
              />
            ) : (
              displayLogs()
            )}
          </div>
          
          <div className="software-log-footer">
            <Button 
              id="cancel-logs"
              variant="secondary"
              size="regular"
              onClick={onClose}
            >
              {t(SOFTWARE_CONSTANTS.cancel)}
            </Button>
            <Button 
              id="refresh-logs"
              variant="primary"
              size="regular"
              onClick={onRefreshClick}
            >
              {t(SOFTWARE_CONSTANTS.refresh)}
            </Button>
          </div>
        </Modal>
  );
};

export default ServiceLogs;